<div class="SCR-interest-pop-area">
    <button class="pop-cls-btn" mat-dialog-close>
        <!-- <img src="assets/img/filter-close-icon.png" class="cls-icn" /> -->
    </button>
    <h3 class="SCR-interest-popup-hdng">Which courses are you <br>interested in?</h3>
    <form>
    <ul class="SCR-interest-popup-chbx-area">
        <li *ngFor="let mode of modes">
            <label>
                <input type="checkbox" value="{{mode?.mode}}" (click)="checkboxInitalise(mode)"  name="{{mode?.mode}}"[checked]="mode?.checked"/>
                <div class="chkcnt">{{mode?.mode}}</div>
            </label>
        </li>
        <!-- <li>
            <label>
                <input type="checkbox" value="2" />
                <div class="chkcnt">Offline Courses</div>
            </label>
        </li> -->
    </ul>

    <div class="SCR-interest-actn-area">
        <button class="btn UNFAPP-blue-btn btn-block" type="button"  [disabled]="!selectedModes?.length" (click)="submitIntersetedCourse()">Submit</button>
    </div>
    
    </form>
</div>
